import * as React from 'react';

import { TenantPortalLogo } from '../../TenantPortalLogo';
import { FlexWrapper } from '../../../Shared/FlexWrapper';

import styles from './isolated-header.module.css';

interface IsolatedLayoutHeaderProps {
    LeftComponent?: React.ReactElement;
    RightComponent?: React.ReactElement;
}

function IsolatedLayoutHeader({
    LeftComponent,
    RightComponent,
}: IsolatedLayoutHeaderProps): React.ReactElement<IsolatedLayoutHeaderProps> {
    return (
        <FlexWrapper align="center" justify="between" className={styles.Header}>
            <div>{!!LeftComponent && LeftComponent}</div>
            <div className={styles.LogoContainer}>
                <TenantPortalLogo />
            </div>
            <div>{!!RightComponent && RightComponent}</div>
        </FlexWrapper>
    );
}

export default IsolatedLayoutHeader;
